import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button, Label, Container, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
 import { BaseUrl } from "../../helpers/Baseurl";

class FormValidations extends Component {
  constructor(props) {
    super(props);
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const is_superuser = obj.user.is_superuser
      if (!is_superuser){
        this.props.history.push('/dashboard')
        }
    }
    this.state = {
      loading: false,
      breadcrumbItems: [
        { title: "Users", link: "/users" },
        { title: "Add User", link: "#" },
      ],
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000

  }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeHandeler.bind(this);

  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")  
    this.props.history.push('/users')
  }

  

  handleSubmit(e,  values) {
    this.setState({ loading: true })
    let data = {"email": values.email,
                "first_name": values.first_name,
                "last_name": values.last_name,
                "password": values.password,
                "phone":values.number}
    const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/accounts/register/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          this.setState({ loading: false })
                          toastr.error(data.email, "")  }
                    )
                }
                else{
                    res.json()
                    .then(
                        (data) =>{
                        this.props.history.push('/users')
                        toastr.success(`${values.email} register`, "")  
                        }
                    )
                }    
            }
        )

    var d1 = document.getElementsByName("validate");
    
    for (var i = 0; i < d1.length; i++) {
      d1[i].style.display = "block";
    }
  }

  //for change tooltip display propery
  changeHandeler(event, eleId) {
    if (event.target.value !== "")
      document.getElementById(eleId).style.display = "none";
    else
      document.getElementById(eleId).style.display = "block";
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>



            <Breadcrumbs title="Add User" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    {/* <h4 className="card-title">Validation type</h4> */}
                 

                    <AvForm onValidSubmit={this.handleSubmit}>
                       <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="first_name">First Name</Label>
                              <AvField
                                name="first_name"
                                placeholder="First Name"
                                type="text"
                                errorMessage="Enter First Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="first_name"
                              />
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="last_name">Last Name</Label>
                              <AvField
                                name="last_name"
                                placeholder="Last Name"
                                type="text"
                                errorMessage="Enter Last Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="last_name"
                              />
                            </div>
                          </Col>
                        </Row>
          
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <AvField
                                name="email"
                                label="E-Mail"
                                placeholder="Enter Valid Email"
                                type="email"
                                errorMessage="Invalid Email"
                                validate={{
                                  required: { value: true },
                                  email: { value: true }
                                }}
                              />
                            </div>
                          </Col>
                           <Col md="6">
                            <div className="mb-3">
                              <AvField
                                name="number"
                                label="Contact No."
                                placeholder="Enter Only number"
                                type="number"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                  
                                  maxLength: {
                                    value: 15,
                                    errorMessage: "Numbers must be less than 16 digit"},
                                  minLength: {
                                    value: 10,
                                    errorMessage: "Numbers must be Grater than 9 digit"}   
                                }}
                              />
                            </div>
                          </Col>
                         </Row>
                    
                        <Row>
                          <Col md="6">  
                            <div className="mb-3">
                              <Label>Password</Label>
                              <AvField
                                name="password"
                                type="password"
                                placeholder="Password"
                                errorMessage="Enter password"
                                validate={{ required: { value: true } }}
                              />
                              </div>
                            </Col>
                            <Col md="6">
                              <div className="mb-3">
                              <Label>Confirm Password</Label>
                              <AvField
                                name="password1"
                                type="password"
                                placeholder="Re-type Password"
                                errorMessage="Enter Re-password"
                                validate={{
                                  required: { value: true },
                                  match: { value: "password" }
                                }}
                              />
                              </div>
                            </Col>
                          </Row>
                      <FormGroup className="mb-0">
                      {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                        
                      </FormGroup>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FormValidations;
